<div class="flex flex-row jcsb aic toggle">
  {{ label }}
  <mat-slide-toggle
    class="ml20"
    [id]="id + '-mat-toggle'"
    [checked]="value"
    [disabled]="disabled"
    (change)="changeChecked($event)"
  ></mat-slide-toggle>
</div>
